exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pe-footer,.pe-footer--stick{padding:24px 0;text-align:center}.pe-footer--stick li,.pe-footer--stick p,.pe-footer--stick ul,.pe-footer li,.pe-footer p,.pe-footer ul{display:inline-block;margin:0;padding:0}.pe-footer--stick span,.pe-footer span{display:inline-block;padding:0 2px}.pe-footer--stick{position:absolute;width:100%;bottom:0;left:0;right:0}.pe-footer--light a,.pe-footer--light a:hover,.pe-footer--light li,.pe-footer--light li:hover,.pe-footer--light p,.pe-footer--light p:hover{color:#fff}@media (max-width:767px){.pe-footer--stick ul,.pe-footer ul{margin-bottom:12px}.pe-footer--stick li:last-child span,.pe-footer li:last-child span{display:none}.pe-footer--stick p,.pe-footer p{display:block;font-size:12px;line-height:16px;text-align:center}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/Footer/Footer.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/Footer/Footer.scss
// module chunks = 0 1 2